import type { ReactNode } from "react";
import Box from "@mui/material/Box";

export const Strong = ({ children }: { children: ReactNode }) => (
  <Box component="span" sx={{ fontWeight: "bold" }}>
    {children}
  </Box>
);
